var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlCupsFilled = function SvgHtlCupsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.438 14.028A.498.498 0 0 1 8.325 14H3.47a.5.5 0 0 1-.5-.44L2 5.56a.5.5 0 0 1 .4-.55h.039a.512.512 0 0 1 .068 0H9.48a.512.512 0 0 1 .081 0 .5.5 0 0 1 .254.109h.006l.007.006a.5.5 0 0 1 .093.123v.005a.5.5 0 0 1 .051.289l-.511 4.1a.5.5 0 0 1-.033.262l-.457 3.666a.5.5 0 0 1-.5.438.633.633 0 0 1-.034.02Zm-2.7-4.447a4.9 4.9 0 0 0 2.77-.2l.421-3.382H3.06l.423 3.5c.31-.082.629-.122.95-.121.444.003.886.072 1.311.203h-.005ZM10.75 11a.5.5 0 0 1 0-1h1.125l1.045-7H7.05l.065.657a.5.5 0 0 1-.836.417.5.5 0 0 1-.162-.323L6 2.551a.5.5 0 0 1 .512-.546h6.961a.507.507 0 0 1 .1 0 .5.5 0 0 1 .31.174.5.5 0 0 1 .106.4L12.8 10.521a.618.618 0 0 1-.557.474L10.75 11Z"
  })));
};
export default SvgHtlCupsFilled;